import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ReactReduxContext } from 'react-redux';
import { closeSnackbar } from 'ui/containers/Notifier/actions';
import { SnackbarProvider as NotiStackSnackbarProvider } from 'notistack';

export const SNACKBAR_VARIANT_TYPE = {
  success: 'success',
  warning: 'warning',
  error: 'error',
  info: 'info',
};

export const ANCHOR_POSITION = {
  topCenter: {
    vertical: 'top',
    horizontal: 'center',
  },
  topRight: {
    vertical: 'top',
    horizontal: 'right',
  },
  topLeft: {
    vertical: 'top',
    horizontal: 'left',
  },
  bottomCenter: {
    vertical: 'bottom',
    horizontal: 'center',
  },
  bottomRight: {
    vertical: 'bottom',
    horizontal: 'right',
  },
  bottomLeft: {
    vertical: 'bottom',
    horizontal: 'left',
  },
};

const ThemeSnackbarProvider = styled(NotiStackSnackbarProvider).attrs({
  classes: {
    variantSuccess: 'success',
    variantError: 'error',
    variantWarning: 'warning',
    variantInfo: 'info',
  },
})`
  .success {
    background-color: ${props => {
      return props.theme.palette.success;
    }};
  }
  .error {
    background-color: ${props => {
      return props.theme.palette.error;
    }};
  }
  .warning {
    background-color: ${props => {
      return props.theme.palette.warning;
    }};
  }
  .info {
    background-color: ${props => {
      return props.theme.palette.info;
    }};
  }
`;

export const SnackbarProvider = props => {
  const { className, maxSnack, autoHideDuration, anchorOrigin, children } = props;

  return (
    <ReactReduxContext.Consumer>
      {({ store }) => {
        const { dispatch } = store;
        return (
          <ThemeSnackbarProvider
            className={className}
            maxSnack={maxSnack}
            autoHideDuration={autoHideDuration}
            anchorOrigin={anchorOrigin}
            action={key => (
              <div onClick={() => dispatch(closeSnackbar(key))} className="mr-3">
                <i className="fa fa-close" style={{ cursor: 'pointer' }} />
              </div>
            )}
            {...props}
          >
            {children}
          </ThemeSnackbarProvider>
        );
      }}
    </ReactReduxContext.Consumer>
  );
};

export const mapDispatchToProps = dispatch => {
  return {
    closeSnackbar: key => dispatch(closeSnackbar(key)),
  };
};

export default SnackbarProvider;

SnackbarProvider.propTypes = {
  maxSnack: PropTypes.number,
  autoHideDuration: PropTypes.number,
  anchorOrigin: PropTypes.shape({
    vertical: PropTypes.string,
    horizontal: PropTypes.string,
  }),
};

SnackbarProvider.defaultProps = {
  maxSnack: 3,
  autoHideDuration: 5000,
  anchorOrigin: ANCHOR_POSITION.topCenter,
};
